// Pass-through wrapper: content is always fully visible.
// (Scroll-triggered fade-in animations removed per owner request — sections
// must never appear to dim while scrolling.)
export const Reveal = ({ children, className = "", as = "div", delay, y, ...rest }) => {
  const Tag = as;
  return (
    <Tag className={className} {...rest}>
      {children}
    </Tag>
  );
};

export default Reveal;
